import { render, staticRenderFns } from "./first_time_request.vue?vue&type=template&id=6b3afd2b&scoped=true&"
import script from "./first_time_request.vue?vue&type=script&lang=js&"
export * from "./first_time_request.vue?vue&type=script&lang=js&"
import style0 from "./first_time_request.vue?vue&type=style&index=0&id=6b3afd2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3afd2b",
  null
  
)

export default component.exports